import { render, staticRenderFns } from "./PlayerH.vue?vue&type=template&id=847711ea&scoped=true"
import script from "./PlayerH.vue?vue&type=script&lang=js"
export * from "./PlayerH.vue?vue&type=script&lang=js"
import style0 from "./PlayerH.vue?vue&type=style&index=0&id=847711ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847711ea",
  null
  
)

export default component.exports